import "./css/tailwind.css";

import { lazy, Suspense, useEffect, useRef, useState } from "react";

import Homepage from "./components/Homepage.js";
import Header from "./components/Header.js";
import Presentation from "./components/Presentation.js";
import Expertise from "./components/Expertise.js";
import Contact from "./components/Contact.js";
import Estimate from "./components/Estimate.js";
import Footer from "./components/Footer.js";

const Gallery = lazy(() => import("./components/Gallery.js"));

function App() {
    const galleryTriggerRef = useRef(null);
    const [shouldLoadGallery, setShouldLoadGallery] = useState(false);

    useEffect(() => {
        if (!("IntersectionObserver" in window)) {
            setShouldLoadGallery(true);
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    setShouldLoadGallery(true);
                    observer.disconnect();
                }
            },
            {
                root: null,
                rootMargin: "600px",
                threshold: 0.01,
            }
        );

        if (galleryTriggerRef.current) observer.observe(galleryTriggerRef.current);

        return () => observer.disconnect();
    }, []);

    return (
        <div id="container" className="bg-gray-300 dark:bg-slate-900 w-full">
            <Header />

            <main>
                <Homepage />
                <Presentation />
                <Expertise />

                <div ref={galleryTriggerRef}>
                    {shouldLoadGallery ? (
                        <Suspense
                            fallback={
                                <div
                                    id="projects"
                                    className="p-6 text-center text-light-text dark:text-dark-text"
                                >
                                    Chargement des réalisations…
                                </div>
                            }
                        >
                            <Gallery />
                        </Suspense>
                    ) : (
                        <div
                            id="projects"
                            className="p-6 text-center text-light-text dark:text-dark-text"
                        >
                            Réalisations : chargement à l’approche…
                        </div>
                    )}
                </div>

                <Contact />
                <Estimate />
            </main>

            <Footer />
        </div>
    );
}

export default App;